import React from 'react'

export default function DownArrow({fill}) {

    return (
        <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.53033 0.723759C9.82322 1.01665 9.82322 1.49153 9.53033 1.78442L5.53033 5.78442C5.23744 6.07731 4.76256 6.07731 4.46967 5.78442L0.46967 1.78442C0.176777 1.49153 0.176777 1.01665 0.46967 0.72376C0.762563 0.430866 1.23744 0.430866 1.53033 0.72376L5 4.19343L8.46967 0.723759C8.76256 0.430866 9.23744 0.430866 9.53033 0.723759Z" fill={fill ? fill : "black"} />
        </svg>

    )
}
